import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-16">
      {/* --- Banner bo‘limi --- */}
      <section className="relative h-64 bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1748256622734-92241ae7b43f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')" }}>
        <div className="absolute inset-0 bg-black opacity-50" />
        <div className="relative container mx-auto h-full flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
            {t('about.title', 'Biz haqimizda')}
          </h1>
        </div>
      </section>

      {/* --- Tarix va rivojlanish bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4 md:flex md:items-center md:space-x-8">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-3xl font-bold text-etmgreen">
              {t('about.historyTitle', 'Tariximiz va rivojlanish')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'about.history1',
                '“Navoi Kompyuter Spektr ETM” MCHJ  2002-yildan beri nazorat kassa  texnikalari (NKT) sohasida yetakchi hisoblanadi. Biz mijozlarimizga zamonaviy, ishonchli va qulay onlayn NKT lar  tizimlarini taqdim etib, biznesingiz samaradorligini oshirishga yordam beramiz. '
              )}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'about.history2',
                'Hozirgi kunda 500 dan ortiq mijozimiz bor va ular orasida do‘konlar, oshxonalar,  restoranlar va supermarketlar mavjud.'
              )}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'about.history3',
                'Biz ONKT larni ishga tushirish, texnik xizmat ko‘rsatish, xodimlarni o‘qitish va 24/7 davomida qo‘llab-quvvatlash xizmatlarini taklif qilamiz. Har bir mahsulotimizga 12 oylik rasmiy kafolat beriladi.'
              )}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'about.history4',
                'Yil sayin innovatsion texnologiyalarga asoslanib xizmat sohamizda yuksak qulayliklar yaratilib bormoqda.'
              )}
            </p>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="https://images.unsplash.com/photo-1531973576160-7125cd663d86?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Kompaniya tarixi"
              className="w-full rounded-lg shadow-lg object-cover h-64 md:h-80"
            />
          </div>
        </div>
      </section>

      {/* --- Maqsadimiz va qadriyatlar bo‘limi --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 text-center space-y-8">
          <h2 className="text-3xl font-bold text-etmgreen">
            {t('about.missionTitle', 'Maqsadimiz va Qadriyatlarimiz')}
          </h2>
          <p className="text-gray-700 leading-relaxed max-w-3xl mx-auto">
            {t(
              'about.missionText',
              'Maqsadimiz – har bir biznes uchun zamonaviy, ishon­ch­li va qulay kassa tizimlarini yaratish orqali ularga operatsion samaradorlik va moliyaviy barqarorlikni ta’minlash. Biz doimo qulaylik, sifat va innovatsiya tamoyillari asosida harakat qilamiz.'
            )}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 pt-8">
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">{t('about.value1Title', 'Inovatsiya')}</h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'about.value1Text',
                  'Yangi texnologiyalarni joriy qilish va doimiy ravishda mahsulotlarimizni yangilash.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">{t('about.value2Title', 'Ishonchlilik')}</h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'about.value2Text',
                  'Mahsulot va xizmatlarimiz har doim barqaror va to’liq qo’llab-quvvatlanadi.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">{t('about.value3Title', 'Mijozga yo‘naltirish')}</h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'about.value3Text',
                  'Har bir mijoz ehtiyojini tinglash, moslashuvchan yechimlar taklif qilish.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">{t('about.value4Title', 'Hamkorlik')}</h3>
              <p className="text-gray-600 text-sm">
                {t(
                  'about.value4Text',
                  'Mahsulot va xizmatlarni doimiy ravishda yanada takomillashtirish uchun hamkorlarni qo‘llab-quvvatlash.'
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Muvaffaqiyatlar bo‘limi --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 text-center space-y-8">
          <h2 className="text-3xl font-bold text-etmgreen">
            {t('about.achievementsTitle', 'Muvaffaqiyatlarimiz')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h4 className="text-xl font-semibold mb-2">
                {t('about.achieve1Title', 'Mualliflik tog‘risidagi guvhnoma. Reestr №000363 12.01.2017 yil.')}
              </h4>
              <p className="text-gray-700 text-sm">
                {t(
                  'about.achieve1Text',
                  'Nazorat kassa mashinalariga servis xizmat ko‘rsatish jarayonlari bo‘yicha ma‘lumotlar bazasi.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h4 className="text-xl font-semibold mb-2">
                {t('about.achieve2Title', '500+ mijoz — 2025')}
              </h4>
              <p className="text-gray-700 text-sm">
                {t(
                  'about.achieve2Text',
                  '2025-yilda bizning xizmatlarimiz 500 dan ortiq mijoz tomonidan tan olindi, shu jumladan katta supermarket zanjirlari va franchayzing tarmoqlari.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h4 className="text-xl font-semibold mb-2">
                {t('about.achieve3Title', 'MILLIY KONSEPSIYA - 2019')}
              </h4>
              <p className="text-gray-700 text-sm">
                {t(
                  'about.achieve3Text',
                  'Fiskal malumotlarni onlayn korinishda Soliq organlariga uzatish MILLIY KONSEPSIYASI 2019 - yil.'
                )}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
              <h4 className="text-xl font-semibold mb-2">
                {t('about.achieve4Title', 'AI asosidagi tahlil xizmati — 2025')}
              </h4>
              <p className="text-gray-700 text-sm">
                {t(
                  'about.achieve4Text',
                  '2025-yilda biz birinchi bo‘lib kassa statistikalarini AI modellar orqali tahlil qilib, biznesga real vaqt rejimida tavsiyalar beruvchi xizmatni ishga tushirdik.'
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Kelajak rejalar bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4 md:flex md:items-center md:space-x-8">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-3xl font-bold text-etmgreen">
              {t('about.futureTitle', 'Kelajak rejalarimiz')}
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>
                {t(
                  'about.future1',
                  'Kontaktless to‘lov tizimini kengaytirish: NFC va QR kod orqali to‘lovlarni qo‘llab-quvvatlashni joriy etish.'
                )}
              </li>
              <li>
                {t(
                  'about.future2',
                  'Sun‘iy intellekt (AI)-dasturiy ta’minotini takomillashtirish: automatizatsiya va oldindan ogohlantirish xabarlarini rivojlantirish.'
                )}
              </li>
              <li>
                {t(
                  'about.future3',
                  'Yangi bozorlar: Respublikamiz bo`yicha internet bozorlariga kirib, xizmatlarimizni yetkazish va imkoniyatlarimizni kengaytirish.'
                )}
              </li>
              <li>
                {t(
                  'about.future4',
                  'Mobil ilovalarni kengaytirish: Android va iOS uchun to‘liq funksional kassir ilovasini ishlab chiqish.'
                )}
              </li>
            </ul>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="https://images.unsplash.com/photo-1485740112426-0c2549fa8c86?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Kelajak rejalar"
              className="w-full rounded-lg shadow-lg object-cover h-64 md:h-80"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
